import rawFontFamilies from "../data/fontFamilies.json";

const FALLBACK_FONT_FAMILIES = [
  {
    value: "sans-serif",
    label: "Sans Serif",
    stack: ["Helvetica Neue", "Helvetica", "Arial", "sans-serif"],
  },
  {
    value: "serif",
    label: "Serif",
    stack: ["Times New Roman", "Times", "serif"],
  },
  {
    value: "monospace",
    label: "Monospace",
    stack: ["Courier New", "Courier", "monospace"],
  },
  {
    value: "arial",
    label: "Arial",
    stack: ["Arial", "Helvetica", "sans-serif"],
  },
  {
    value: "georgia",
    label: "Georgia",
    stack: ["Georgia", "Times New Roman", "serif"],
  },
  {
    value: "times-new-roman",
    label: "Times New Roman",
    stack: ["Times New Roman", "Times", "serif"],
  },
  {
    value: "trebuchet-ms",
    label: "Trebuchet MS",
    stack: ["Trebuchet MS", "Helvetica", "sans-serif"],
  },
  {
    value: "comic-sans-ms",
    label: "Comic Sans MS",
    stack: ["Comic Sans MS", "Comic Sans", "cursive"],
  },
];

const quoteFontIfNeeded = (name = "") => {
  const trimmed = `${name}`.trim();

  if (!trimmed) {
    return "";
  }

  if (/^['"].*['"]$/.test(trimmed) || !/\s/.test(trimmed)) {
    return trimmed;
  }

  return `'${trimmed}'`;
};

const normaliseFontFamilies = (input) => {
  if (Array.isArray(input)) {
    const cleaned = input
      .map((entry) => {
        if (!entry || typeof entry !== "object") {
          return null;
        }

        const value = `${entry.value || ""}`.trim();
        const label = `${entry.label || value}`.trim();
        const stackArray = Array.isArray(entry.stack)
          ? entry.stack
          : entry.stack && typeof entry.stack === "string"
          ? entry.stack.split(",")
          : [];

        if (!value) {
          return null;
        }

        const stack = stackArray
          .map((font) => quoteFontIfNeeded(font))
          .filter(Boolean)
          .join(", ");

        return {
          value,
          label: label || value,
          stack: stack || value,
        };
      })
      .filter(Boolean);

    if (cleaned.length > 0) {
      return cleaned;
    }
  }

  return FALLBACK_FONT_FAMILIES.map((font) => ({
    ...font,
    stack: font.stack.map((name) => quoteFontIfNeeded(name)).join(", "),
  }));
};

const FONT_FAMILIES = normaliseFontFamilies(rawFontFamilies);

const FONT_WHITELIST = FONT_FAMILIES.map((font) => font.value);

const FONT_FAMILY_MAP = FONT_FAMILIES.reduce((acc, font) => {
  acc[font.value] = font;
  return acc;
}, {});

let fontStylesInjected = false;

export const ensureLessonFontStyles = () => {
  if (fontStylesInjected || typeof document === "undefined") {
    return;
  }

  const styleId = "lesson-font-families";
  if (document.getElementById(styleId)) {
    fontStylesInjected = true;
    return;
  }

  const cssRules = FONT_FAMILIES.map((font) => {
    const { value, stack } = font;

    if (!value || !stack) {
      return null;
    }

    return `.ql-font-${value}, .lesson-content .ql-font-${value} { font-family: ${stack}; }`;
  })
    .filter(Boolean)
    .join("\n");

  if (!cssRules) {
    fontStylesInjected = true;
    return;
  }

  const style = document.createElement("style");
  style.id = styleId;
  style.type = "text/css";
  style.appendChild(document.createTextNode(cssRules));
  document.head.appendChild(style);

  fontStylesInjected = true;
};

export { FONT_FAMILIES, FONT_FAMILY_MAP, FONT_WHITELIST };
